module.exports = __webpack_public_path__ + "static/5-PROPTECH-TRENDS-430a66d0d40d3ac2539e68ea12a126e2.png";